var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-action"},[_c('router-link',{attrs:{"to":_vm.url}},[_c('CIcon',{directives:[{name:"c-tooltip",rawName:"v-c-tooltip",value:('Editar'),expression:"'Editar'"}],attrs:{"name":"cil-pencil","placement":"top"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }